import { EtcGrapeFlatIcon, EtcZombieIcon } from '@assets/iconComponents';
import { CheckboxItem, MenuTop, Output, Text } from '@components';
import { EtcChildOptionValueEnum, styleConstant } from '@constant';
import { useOutput } from '@hooks';
import { useEtcActions } from '@remote-hooks';
import { colorSet } from '@theme';
import { useEffect, useState } from 'react';

const EtcOutputPage = () => {
  const { storedEtcChildOptionValue, onSetEtc } = useOutput();

  // 마운트 상태를 추적하는 state
  const [isComponentMounted, setIsComponentMounted] = useState(false);

  const { onInitEtc } = useEtcActions();

  useEffect(() => {
    setIsComponentMounted(true);
    if (!isComponentMounted) return;

    return () => {
      onInitEtc();
    };
  }, [isComponentMounted, onInitEtc]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <MenuTop />

      {/* 옵션 */}
      <div
        style={{
          height: styleConstant.topPageNameHeight,
          padding: '40px',
          borderBottom: `1px solid ${colorSet.gray300}`
        }}
      >
        <Text variant="h2" fontWeight="bold">
          기타
        </Text>
      </div>

      <div style={{ display: 'flex' }}>
        {/* 좌측 메뉴 */}
        <div
          style={{
            width: styleConstant.outputPageLeftMenuWidth,
            padding: '24px 32px',
            backgroundColor: colorSet.gray100,
            boxSizing: 'border-box',
            position: 'sticky',
            top: styleConstant.menuTopHeight,
            minHeight: `calc(100vh - ${styleConstant.menuTopHeight + styleConstant.topPageNameHeight}px)`,
            maxHeight: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
            borderRight: `1px solid ${colorSet.gray300}`
          }}
        >
          <Text variant="body1" fontWeight="bold">
            하위 스페셜 단추
          </Text>
          <div style={{ width: 224, padding: '8px 24px 8px 0px', marginTop: '8px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '24px 0px' }}>
              <CheckboxItem
                label="오브젝트"
                imageComponent={<EtcGrapeFlatIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedEtcChildOptionValue[EtcChildOptionValueEnum.오브젝트]}
                onChange={() => {
                  onSetEtc({
                    [EtcChildOptionValueEnum.오브젝트]: !storedEtcChildOptionValue[EtcChildOptionValueEnum.오브젝트]
                  });
                }}
              />
              <CheckboxItem
                label="인외존재"
                imageComponent={<EtcZombieIcon style={{ width: 48, height: 48 }} />}
                imageAlign="column"
                isChecked={storedEtcChildOptionValue[EtcChildOptionValueEnum.인외존재]}
                onChange={() => {
                  onSetEtc({
                    [EtcChildOptionValueEnum.인외존재]: !storedEtcChildOptionValue[EtcChildOptionValueEnum.인외존재]
                  });
                }}
              />
            </div>
          </div>
        </div>

        {/* 검색 결과 */}
        <Output />
      </div>
    </div>
  );
};

export default EtcOutputPage;
